import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SettingsProvider, getDefaultSettings } from './providers/settings_provider';


const widgetDivs = document.getElementsByClassName('cabi-widget');

Array.from(widgetDivs).forEach((element) => {
  const root = ReactDOM.createRoot(element as HTMLElement);

  const rawSettings = element.getAttribute('data-default-settings');
  if (rawSettings) {
    try {
      const parsed = JSON.parse(rawSettings);
      const settings = getDefaultSettings(parsed);

      root.render(
        <React.StrictMode>
          <SettingsProvider value={settings}>
            <App />
          </SettingsProvider>
        </React.StrictMode>
      );
    } catch (err) {
      console.error("Invalid widget settings:", err);
    }
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
